<!-- eslint-disable -->
<template>
  <div class="moduleStyle minHeight" style="position:relative;">
    <div class="trade-header"> 
      <el-tabs v-model="activeTab" @tab-click="onTabChange" class="trade-tabs">
        <el-tab-pane label="指标配置" name="config"></el-tab-pane>
        <el-tab-pane label="指标类型" name="type"></el-tab-pane>
        <el-tab-pane label="指标定义" name="indicator"></el-tab-pane>
        <el-tab-pane label="部门维护" name="dept"></el-tab-pane>
      </el-tabs>
    </div>
    <el-button v-if="activeTab==='config'" type="primary" size="small" icon="el-icon-plus" @click="openAddDialog()" style="position:absolute;top:12px;right:20px;z-index:10;">添加指标</el-button>

    <!-- 指标配置 -->
    <div v-if="activeTab === 'config'">
      <div class="config-filter-bar">

      </div>
      <div class="config-table-wrap">
        <!-- 卡片视图 -->
        <div v-if="viewMode === 'cards'" v-loading="basicListconfig.loading" class="kpi-card-grid" :style="{ maxHeight: tableHeight, overflowY: 'auto' }">
          <div class="kpi-card" v-for="row in pagedHorizontalData" :key="row.target_id">
            <div class="kpi-card-header">
              <span class="kpi-card-title">{{ row.name }}</span>
              <el-button type="text" size="mini" icon="el-icon-edit" @click="editRow(row)"></el-button>
            </div>
            <div class="kpi-card-body">
              <div class="kpi-item" v-for="def in usedIndicators" :key="def.indicator_code" v-if="row['val_'+def.indicator_code] !== ''">
                <span class="kpi-label">{{ def.indicator_name }}</span>
                <span class="kpi-value">{{ row['val_'+def.indicator_code] }}</span>
                <span v-if="row['pct_'+def.indicator_code] !== ''" class="kpi-pct">{{ row['pct_'+def.indicator_code] }}%</span>
              </div>
            </div>
          </div>
        </div>

        <el-pagination
          v-if="horizontalData.length > configPageSize"
          style="margin-top:10px;text-align:right;"
          background
          layout="total, prev, pager, next"
          :total="horizontalData.length"
          :page-size="configPageSize"
          :current-page.sync="configPage"
          :pager-count="5"
          size="small">
        </el-pagination>
        <div class="table_footer">
          <p class="table_footer_total">共 {{ targetColumns.length }} 个目标</p>
        </div>
      </div>
    </div>

    <!-- 指标类型 Tab -->
    <div v-if="activeTab === 'type'">
      <div style="text-align:right;padding:8px 0;">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openTypeDialog()">创建配置</el-button>
      </div>
      <el-table :data="pagedTypeConfigList" border size="small" stripe max-height="calc(100vh - 310px)">
        <el-table-column prop="name" label="配置名称" min-width="160"></el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">{{ typeMap[scope.row.target_type] || '未知' }}</template>
        </el-table-column>
        <el-table-column prop="target_name" label="目标" width="140"></el-table-column>
        <el-table-column prop="period" label="周期" width="100"></el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openTypeDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#F56C6C" @click="delTypeConfig(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="typeConfigList.length > 10"
        style="margin-top:10px;text-align:right;"
        background
        layout="total, prev, pager, next"
        :total="typeConfigList.length"
        :page-size="10"
        :current-page.sync="typePage"
        :pager-count="5"
        size="small">
      </el-pagination>
    </div>

    <!-- 指标定义 Tab -->
    <div v-if="activeTab === 'indicator'">
      <div style="text-align:right;padding:8px 0;">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openIndicatorForm()">新增指标</el-button>
      </div>
      <el-table :data="pagedIndicatorDefinitions" border size="small" stripe max-height="calc(100vh - 320px)">
        <el-table-column prop="indicator_name" label="指标名称" min-width="140"></el-table-column>
        <el-table-column prop="indicator_code" label="编码" width="160"></el-table-column>
        <el-table-column prop="indicator_type" label="类型" width="80">
          <template slot-scope="scope">{{ scope.row.indicator_type == 1 ? '周累计' : '时间点' }}</template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sort_order" label="排序" width="60" align="center"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openIndicatorForm(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#F56C6C" @click="deleteIndicator(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="indicatorDefinitions.length > 10"
        style="margin-top:10px;text-align:right;"
        background
        layout="total, prev, pager, next"
        :total="indicatorDefinitions.length"
        :page-size="10"
        :current-page.sync="indicatorPage"
        @current-change="v => indicatorPage = v"
        :pager-count="5"
        size="small">
      </el-pagination>
    </div>

    <!-- 部门维护 Tab -->
    <div v-if="activeTab === 'dept'">
      <div style="text-align:right;padding:8px 0;">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openDeptDialog()">新增部门</el-button>
      </div>
      <el-table :data="departmentList" border size="small" stripe max-height="calc(100vh - 260px)">
        <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
        <el-table-column prop="name" label="部门名称" min-width="140"></el-table-column>
        <el-table-column prop="shop_names" label="关联门店" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1 ? 'success' : 'info'" size="small">{{ scope.row.status == 1 ? '启用' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDeptDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#F56C6C" @click="deleteDept(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 部门弹窗 -->
    <el-dialog :title="'编辑 ' + addTargetName + ' 指标'" :visible.sync="addDialogVisible" width="900px" :close-on-click-modal="false">
      <div style="margin-bottom:15px;display:flex;gap:12px;align-items:center;">
        <el-select v-model="addConfigIndex" size="small" placeholder="选择指标配置" style="width:280px" @change="onAddConfigChange" filterable>
          <el-option v-for="(c, i) in addConfigList" :key="c.id" :value="i" :label="c.name"></el-option>
        </el-select>
        <el-select v-model="addPickCode" size="small" placeholder="选择要添加的指标" filterable clearable style="width:260px" @change="pickIndicator">
          <el-option v-for="d in availableIndicators" :key="d.indicator_code" :value="d.indicator_code" :label="d.indicator_name"></el-option>
        </el-select>
        <el-tag size="small" type="info">共 {{ addEditList.length }} 个指标</el-tag>
      </div>
      <el-table :data="addEditList" border size="small" max-height="450" style="width:100%">
        <el-table-column prop="indicator_name" label="指标名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="target_value" label="目标值" width="130" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.target_value" size="small" placeholder="请输入" style="width:100px;"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="占比(%)" width="100" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.weight" size="small" placeholder="%" style="width:70px;"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="100" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.sort_order" :min="0" size="small" controls-position="right" style="width:85px;"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="is_capped" label="封顶设置" width="180" align="center">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
              <el-checkbox v-model="scope.row.is_capped">启用上限</el-checkbox>
              <el-input v-if="scope.row.is_capped" v-model="scope.row.cap_value" size="small" placeholder="上限%" style="width:80px;"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" style="color:#F56C6C" @click="removeAddEdit(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" style="padding:15px 20px;">
        <el-button size="small" @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="confirmAddIndicators">保存</el-button>
      </div>
    </el-dialog>

    <!-- 指标类型弹窗 -->
    <el-dialog :title="typeEditId ? '编辑指标配置' : '创建指标配置'" :visible.sync="typeDialogVisible" width="450px" :close-on-click-modal="false">
      <el-form label-width="80px" size="small">
        <el-form-item label="类型" required>
          <el-select v-model="typeFormTargetType" style="width:100%" :disabled="!!typeEditId" @change="typeTargetId = null">
            <el-option v-for="(v, k) in typeMap" :key="k" :value="Number(k)" :label="v"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标">
          <el-select v-model="typeTargetId" style="width:100%" filterable :disabled="!!typeEditId">
            <el-option v-for="t in typeTargetList" :key="t.id" :value="t.id" :label="t.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期">
          <el-select v-model="typePeriod" style="width:100%" :disabled="!!typeEditId">
            <el-option v-for="p in periodOptions" :key="p" :value="p" :label="p"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="typeName" placeholder="如：A门店6月指标"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="typeDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveTypeConfig">创建</el-button>
      </div>
    </el-dialog>

    <!-- 指标编辑弹窗 -->
    <el-dialog :title="indicatorForm.id ? '编辑指标' : '新增指标'" :visible.sync="indicatorVisible" width="480px" :close-on-click-modal="false" @closed="indicatorForm = {}">
      <el-form :model="indicatorForm" label-width="80px" size="small">
        <el-form-item label="指标名称" required>
          <el-input v-model="indicatorForm.indicator_name" placeholder="如：整体销售额"></el-input>
        </el-form-item>
        <el-form-item label="编码" required>
          <el-input v-model="indicatorForm.indicator_code" placeholder="英文编码" :disabled="!!indicatorForm.id"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="indicatorForm.indicator_type" style="width:100%">
            <el-option :value="1" label="周累计"></el-option>
            <el-option :value="2" label="时间点"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="indicatorForm.description" placeholder="指标说明"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="indicatorForm.sort_order" :min="0" style="width:100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="indicatorVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveIndicator">保存</el-button>
      </div>
    </el-dialog>

    <!-- 部门编辑弹窗 -->
    <el-dialog :title="deptForm.id ? '编辑部门' : '新增部门'" :visible.sync="deptVisible" width="500px" :close-on-click-modal="false" @closed="deptForm = {}">
      <el-form :model="deptForm" label-width="80px" size="small">
        <el-form-item label="部门名称" required>
          <el-input v-model="deptForm.name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="关联门店">
          <el-select v-model="deptForm.shop_ids" multiple filterable placeholder="请选择门店" style="width:100%">
            <el-option v-for="s in storeList" :key="s.id" :value="s.id" :label="s.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="deptForm.status" style="width:100%">
            <el-option :value="1" label="启用"></el-option>
            <el-option :value="0" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="deptVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveDept">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { gettradelist, tradeSave, tradeDel, getIndicatorDefinitions, saveIndicatorDefinition, delIndicatorDefinition, getDepartmentList, departmentAdd, departmentUp, departmentDel, getshoplist, initIndicatorDefs } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import { mapGetters } from "vuex";
export default {
  name: "tradeManagement",
  data() {
    return {
      compId: null,
      activeTab: 'config',
      targetType: 1,
      currentPeriod: '',
      periodOptions: [],
      indicatorDefinitions: [],
      storeList: [],
      departmentList: [],
      indicatorVisible: false,
      indicatorForm: {},
      initLoading: false,
      indicatorPage: 1,
      addDialogVisible: false,
      addConfigIndex: null,
      addConfigList: [],
      addTargetName: '',
      addEditList: [],
      addPickCode: '',
      typeDialogVisible: false,
      typeConfigList: [],
      typePage: 1,
      typeEditId: 0,
      typeTargetId: null,
      typeFormTargetType: 1,
      typePeriod: '',
      typeName: '',
      typeMap: { 1: '门店', 2: '部门' },
      filterShopId: null,
      configTargetType: 1,
      deptVisible: false,
      deptForm: {},
      viewMode: 'cards',
      configPage: 1,
      configPageSize: 20,
      tableHeight: 'calc(100vh - 340px)',
      basicListconfig: {
        loading: false,
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.init();
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
    typeTargetList() {
      const tt = this.activeTab === 'config' ? this.configTargetType : this.typeFormTargetType;
      if (tt === 2) {
        return this.departmentList.map(d => ({ id: Number(d.id), name: d.name }));
      }
      return this.storeList.map(s => ({ id: s.id, name: s.name }));
    },
    targetColumns() {
      if (!this.basicListconfig.data || this.basicListconfig.data.length === 0) { return []; }
      const map = new Map();
      this.basicListconfig.data.forEach(item => {
        if (item.indicators && Object.keys(item.indicators).length > 0 && !map.has(item.target_id)) {
          map.set(item.target_id, { target_id: item.target_id, name: item.name || item.target_name || '' });
        }
      });
      return Array.from(map.values());
    },
    // 有数据的指标才显示列
    usedIndicators() {
      const codes = new Set();
      this.horizontalData.forEach(item => {
        Object.keys(item._rawIndicators || {}).forEach(k => codes.add(k));
      });
      return this.indicatorDefinitions.filter(d => codes.has(d.indicator_code));
    },
    // 横向表数据（只显示有指标配置的门店）
    horizontalData() {
      return this.basicListconfig.data
        .filter(item => item.indicators && Object.keys(item.indicators).length > 0)
        .map(item => {
        // 名称优先显示门店名，配置名有值时追加
        const shopName = item.target_name || '';
        const configName = item.name || '';
        const displayName = configName ? (shopName + ' - ' + configName) : shopName;
        const row = { target_id: item.target_id, target_type: item.target_type, name: displayName || '', _rawIndicators: item.indicators || {} };
        this.indicatorDefinitions.forEach(def => {
          const ind = (item.indicators || {})[def.indicator_code] || {};
          row['val_' + def.indicator_code] = ind.target_value !== undefined ? ind.target_value : '';
          row['pct_' + def.indicator_code] = ind.weight !== undefined ? ind.weight : '';
        });
        return row;
      });
    },
    // 当前弹窗目标的可添加指标（排除已配置的）
    availableIndicators() {
      const cfg = this.addConfigIndex !== null ? this.addConfigList[this.addConfigIndex] : null;
      if (!cfg) { return this.indicatorDefinitions; }
      const targetData = this.basicListconfig.data.find(d => d.id == cfg.id);
      const existing = targetData ? Object.keys(targetData.indicators || {}) : [];
      return this.indicatorDefinitions.filter(d => !existing.includes(d.indicator_code));
    },
    // 竖排：列（门店/配置）
    verticalColumns() {
      return this.horizontalData.map(r => ({ target_id: r.target_id, name: r.name }));
    },
    // 竖排：行（指标），值为每个门店的 target_value + weight
    verticalData() {
      return this.usedIndicators.map(def => {
        const row = { indicator_code: def.indicator_code, indicator_name: def.indicator_name };
        this.horizontalData.forEach(hr => {
          row['t_' + hr.target_id] = hr['val_' + def.indicator_code];
          row['p_' + hr.target_id] = hr['pct_' + def.indicator_code];
        });
        return row;
      }).filter(r => Object.keys(r).some(k => k.startsWith('t_') && r[k] !== ''));
    },
    pagedHorizontalData() {
      const start = (this.configPage - 1) * this.configPageSize;
      return this.horizontalData.slice(start, start + this.configPageSize);
    },
    pagedVerticalData() {
      const start = (this.configPage - 1) * this.configPageSize;
      return this.verticalData.slice(start, start + this.configPageSize);
    },
    pagedTypeConfigList() {
      const start = (this.typePage - 1) * 10;
      return this.typeConfigList.slice(start, start + 10);
    },
    pagedIndicatorDefinitions() {
      const start = (this.indicatorPage - 1) * 10;
      return this.indicatorDefinitions.slice(start, start + 10);
    },
    configuredCodes() {
      const codes = new Set();
      if (!this.basicListconfig.data) { return codes; }
      this.basicListconfig.data.forEach(item => {
        const inds = item.indicators || {};
        Object.keys(inds).forEach(k => codes.add(k));
      });
      return codes;
    },
  },
  methods: {
    init() {
      const now = new Date();
      for (let i = 0; i < 12; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        this.periodOptions.push(d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'));
      }
      this.currentPeriod = this.periodOptions[0];
      this.fetchIndicatorDefinitions();
      this.obtainDataSource();
      this.getlist();
    },
    onConfigTypeChange() {
      this.getlist();
    },
    onPeriodChange() {
      this.getlist();
    },
    fetchIndicatorDefinitions() {
      getIndicatorDefinitions({ comp_id: this.compId }).then(res => {
        if (res.code == 1) { this.indicatorDefinitions = res.data || []; this.indicatorPage = 1; }
      });
    },
    initIndicators() {
      this.initLoading = true;
      initIndicatorDefs().then(res => {
        this.initLoading = false;
        if (res.code == 1) {
          this.$message.success(res.msg || '初始化成功');
          this.fetchIndicatorDefinitions();
        } else {
          this.$message.info(res.msg || '已完成初始化');
        }
        this.fetchIndicatorDefinitions();
      }).catch(() => {
        this.initLoading = false;
        this.$message.error('初始化失败');
      });
    },
    onTabChange(tab) {
      if (tab.name === 'indicator') {
        this.fetchIndicatorDefinitions();
      } else if (tab.name === 'type') {
        this.fetchTypeConfigs();
      } else if (tab.name === 'dept') {
        this.fetchDeptList();
      } else {
        this.getlist();
      }
    },
    openTypeDialog(row) {
      if (row) {
        this.typeEditId = row.id;
        this.typeFormTargetType = Number(row.target_type);
        this.typeTargetId = Number(row.target_id);
        this.typePeriod = row.period;
        this.typeName = row.name;
      } else {
        this.typeEditId = 0;
        this.typeFormTargetType = 1;
        this.typeTargetId = null;
        this.typePeriod = this.currentPeriod;
        this.typeName = '';
      }
      this.typeDialogVisible = true;
    },
    fetchTypeConfigs() {
      gettradelist({ comp_id: this.compId, target_type: 0 }).then(res => {
        if (res.code == 1) { this.typeConfigList = (res.data || []).filter(item => item.id > 0); this.typePage = 1; }
      });
    },
    saveTypeConfig() {
      if (!this.typeFormTargetType) { this.$message.warning('请选择类型'); return; }
      if (!this.typeTargetId) { this.$message.warning('请选择目标'); return; }
      if (!this.typeName) { this.$message.warning('请输入配置名称'); return; }
      tradeSave({
        comp_id: this.compId,
        target_type: this.typeFormTargetType,
        target_id: this.typeTargetId,
        period: this.typePeriod,
        name: this.typeName,
        indicators: [],
        id: this.typeEditId,
      }).then(res => {
        if (res.code == 1) { this.$message.success('创建成功'); this.typeDialogVisible = false; this.fetchTypeConfigs(); }
        else this.$message.error(res.msg || '创建失败');
      });
    },
    delTypeConfig(row) {
      this.$confirm('确定删除该配置？', '提示', { type: 'warning' }).then(() => {
        tradeDel({ id: row.id }).then(res => {
          if (res.code == 1) { this.$message.success('删除成功'); this.fetchTypeConfigs(); }
          else this.$message.error(res.msg || '删除失败');
        });
      }).catch(() => {
        // ignore
      });
    },
    obtainDataSource() {
      const roles = JSON.parse(getRoles());
      getshoplist({ status: 0, comp_id: roles.comp_id }).then(res => {
        if (res.code == 1) this.storeList = res.data;
      });
      getDepartmentList({ comp_id: roles.comp_id }).then(res => {
        if (res.code == 1) this.departmentList = res.data || [];
      });
    },
    editRow(row) {
      this.addConfigList = [];
      this.addConfigIndex = null;
      this.addTargetName = '';
      this.addEditList = [];
      this.addPickCode = '';
      this.addDialogVisible = true;
      // 加载配置列表后定位到该行对应的配置
      gettradelist({ comp_id: this.compId, target_type: 0 }).then(res => {
        if (res.code == 1) {
          this.addConfigList = (res.data || []).filter(item => item.id > 0);
          // 找到对应配置
          const rawItem = this.basicListconfig.data.find(d => d.target_id == row.target_id && d.target_type == row.target_type);
          const targetCfg = rawItem ? this.addConfigList.find(c => c.id == rawItem.id) : null;
          if (targetCfg) {
            const idx = this.addConfigList.indexOf(targetCfg);
            this.addConfigIndex = idx;
            this.onAddConfigChange(idx);
          }
        }
      });
    },
    openAddDialog() {
      // 获取已创建的 shop_trade 配置列表
      this.addConfigList = [];
      this.addConfigIndex = null;
      this.addTargetName = '';
      this.addEditList = [];
      this.addPickCode = '';
      this.addDialogVisible = true;
      this.fetchAddConfigList();
    },
    fetchAddConfigList() {
      gettradelist({ comp_id: this.compId, target_type: 0 }).then(res => {
        if (res.code == 1) this.addConfigList = (res.data || []).filter(item => item.id > 0);
      });
    },
    onAddConfigChange(index) {
      if (index === null || index === undefined) {
        this.addEditList = [];
        this.addTargetName = '';
        return;
      }
      const cfg = this.addConfigList[index];
      this.addTargetName = cfg ? cfg.name : '';
      // 加载该配置已有的指标
      gettradelist({ comp_id: this.compId, target_type: cfg.target_type, period: cfg.period }).then(res => {
        if (res.code == 1) {
          const targetData = (res.data || []).find(d => d.id == cfg.id);
          const indicators = targetData ? (targetData.indicators || {}) : {};
          this.addEditList = Object.keys(indicators).map(code => {
            const ind = indicators[code] || {};
            const def = this.indicatorDefinitions.find(d => d.indicator_code === code);
            return {
              indicator_code: code,
              indicator_name: def ? def.indicator_name : code,
              target_value: ind.target_value !== undefined ? ind.target_value : '',
              weight: ind.weight !== undefined ? ind.weight : '',
              sort_order: ind.sort_order !== undefined ? ind.sort_order : 0,
              is_capped: !!(ind.is_capped),
              cap_value: ind.cap_value !== null && ind.cap_value !== undefined ? ind.cap_value : '',
            };
          });
        }
      });
      this.addPickCode = '';
    },
    pickIndicator(code) {
      if (!code) { return; }
      if (this.addEditList.find(i => i.indicator_code === code)) { this.$message.info('已存在'); this.addPickCode = ''; return; }
      const def = this.indicatorDefinitions.find(d => d.indicator_code === code);
      this.addEditList.push({
        indicator_code: code,
        indicator_name: def ? def.indicator_name : code,
        target_value: '',
        weight: '',
      });
      this.addPickCode = '';
    },
    removeAddEdit(index) {
      this.addEditList.splice(index, 1);
    },
    confirmAddIndicators() {
      if (this.addConfigIndex === null) { this.$message.warning('请选择指标配置'); return; }
      const cfg = this.addConfigList[this.addConfigIndex];
      if (!cfg) { return; }
      const indicators = {};
      let ratioSum = 0;
      this.addEditList.forEach(ind => {
        indicators[ind.indicator_code] = {
          indicator_code: ind.indicator_code,
          target_value: ind.target_value || 0,
          weight: ind.weight || 0,
          sort_order: ind.sort_order || 0,
          is_capped: ind.is_capped ? 1 : 0,
          cap_value: ind.is_capped ? (ind.cap_value || null) : null,
        };
        ratioSum += Number(ind.weight || 0);
      });
      if (ratioSum > 100) { this.$message.error('占比总和不能超过 100%，当前：' + ratioSum + '%'); return; }
      tradeSave({
        comp_id: this.compId, target_type: cfg.target_type, target_id: cfg.target_id,
        indicators: Object.values(indicators),
        period: cfg.period,
        id: cfg.id,
        name: cfg.name || '',
      }).then(res => {
        if (res.code == 1) {
          this.$message.success('保存成功');
          this.addDialogVisible = false;
          this.getlist();
        } else this.$message.error(res.msg || '保存失败');
      });
    },
    openIndicatorForm(row) {
      if (row) {
        this.indicatorForm = { ...row, indicator_type: Number(row.indicator_type) };
      } else {
        this.indicatorForm = { id: 0, indicator_code: '', indicator_name: '', indicator_type: 1, description: '', sort_order: this.indicatorDefinitions.length + 1 };
      }
      this.indicatorVisible = true;
    },
    saveIndicator() {
      const f = this.indicatorForm;
      if (!f.indicator_name || !f.indicator_code) { this.$message.warning('指标名称和编码不能为空'); return; }
      saveIndicatorDefinition({
        id: f.id || 0, indicator_code: f.indicator_code, indicator_name: f.indicator_name,
        indicator_type: f.indicator_type, sort_order: f.sort_order, comp_id: this.compId, description: f.description,
      }).then(res => {
        if (res.code == 1) { this.$message.success('保存成功'); this.indicatorVisible = false; this.fetchIndicatorDefinitions(); }
        else this.$message.error(res.msg || '保存失败');
      });
    },
    deleteIndicator(row) {
      this.$confirm('确定删除该指标？', '提示', { type: 'warning' }).then(() => {
        delIndicatorDefinition({ id: row.id }).then(res => {
          if (res.code == 1) { this.$message.success('删除成功'); this.fetchIndicatorDefinitions(); }
          else this.$message.error(res.msg || '删除失败');
        });
      }).catch(() => {
        // ignore
      });
    },
    fetchDeptList() {
      getDepartmentList({ comp_id: this.compId }).then(res => {
        if (res.code == 1) this.departmentList = res.data || [];
      });
    },
    openDeptDialog(row) {
      if (row) {
        const ids = row.shop_ids ? String(row.shop_ids).split(',').map(Number) : [];
        this.deptForm = { id: row.id, name: row.name, status: Number(row.status), shop_ids: ids };
      } else {
        this.deptForm = { id: 0, name: '', status: 1, shop_ids: [] };
      }
      this.deptVisible = true;
    },
    saveDept() {
      const f = this.deptForm;
      if (!f.name) { this.$message.warning('部门名称不能为空'); return; }
      const api = f.id ? departmentUp : departmentAdd;
      const data = f.id
        ? { id: f.id, name: f.name, status: Number(f.status), shop_ids: (f.shop_ids || []).join(',') }
        : { comp_id: this.compId, name: f.name, shop_ids: (f.shop_ids || []).join(',') };
      api(data).then(res => {
        if (res.code == 1) { this.$message.success('保存成功'); this.deptVisible = false; this.fetchDeptList(); }
        else this.$message.error(res.msg || '保存失败');
      });
    },
    deleteDept(row) {
      this.$confirm('确定删除该部门？', '提示', { type: 'warning' }).then(() => {
        departmentDel({ id: row.id }).then(res => {
          if (res.code == 1) { this.$message.success('删除成功'); this.fetchDeptList(); }
          else this.$message.error(res.msg || '删除失败');
        });
      }).catch(() => {
        // ignore
      });
    },
    getlist() {
      this.basicListconfig.loading = true;
      const base = { comp_id: this.compId, period: this.currentPeriod };
      Promise.all([
        gettradelist({ ...base, target_type: 1 }),
        gettradelist({ ...base, target_type: 2 })
      ]).then(([res1, res2]) => {
        this.basicListconfig.loading = false;
        const d1 = res1.code == 1 ? (res1.data || []) : [];
        const d2 = res2.code == 1 ? (res2.data || []) : [];
        this.basicListconfig.data = [...d1, ...d2];
        this.basicListconfig.total = this.basicListconfig.data.length;
        this.configPage = 1;
      }).catch((err) => {
        this.basicListconfig.loading = false;
        this.basicListconfig.data = [];
        this.basicListconfig.total = 0;
        console.error('getlist error:', err);
      });
    },
  },
};
</script>

<style scoped>
.trade-header {
  display: flex;
  align-items: center;
  padding: 12px 20px 0;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}
.trade-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  white-space: nowrap;
}
.trade-tabs {
  margin-bottom: -1px;
}
.trade-tabs >>> .el-tabs__header {
  margin-bottom: 0;
}
.config-filter-bar {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #fff;
}
.config-table-wrap {
  padding: 0 20px;
  background: #fff;
}
.table_footer {
  padding: 10px 0;
  text-align: right;
  color: #606266;
  font-size: 13px;
}
.table_footer_total {
  margin: 0;
}
/* KPI 卡片网格 */
.kpi-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  padding: 4px 0;
}
.kpi-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  transition: box-shadow 0.2s;
}
.kpi-card:hover { box-shadow: 0 2px 12px rgba(0,0,0,0.1); }
.kpi-card-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafbfc;
  border-radius: 8px 8px 0 0;
}
.kpi-card-title {
  font-size: 15px; font-weight: 600; color: #303133;
}
.kpi-card-body {
  padding: 8px 16px 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 16px;
}
.kpi-item {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 0;
  border-bottom: 1px dashed #f0f0f0;
}
.kpi-item:last-child, .kpi-item:nth-last-child(2) { border: none; }
.kpi-label {
  font-size: 12px; color: #909399; flex-shrink: 0;
}
.kpi-value {
  font-size: 14px; font-weight: 600; color: #303133; margin-left: auto;
}
.kpi-pct {
  font-size: 12px; color: #67c23a; flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/tradeManagement/index.vue